/* sticky header - browser-controls offset */

(function () {
  'use strict';

  var vv = window.visualViewport;
  var host = document.getElementById('header-group');
  if (!vv || !host) return;

  var last = -1;
  var frame = 0;

  function write() {
    frame = 0;

    var top = vv.scale > 1.01 ? 0 : vv.offsetTop;
    if (Math.abs(top - last) < 0.5) return;

    last = top;
    host.style.setProperty('--yg-visual-viewport-top', top + 'px');
  }

  function sync() {
    if (frame) return;
    frame = requestAnimationFrame(write);
  }

  vv.addEventListener('scroll', sync, { passive: true });
  vv.addEventListener('resize', sync, { passive: true });
  write();
})();
